module.exports = __webpack_public_path__ + "img/car@2x.e0b24a31.png";